<template>
<b-container fluid>
  <h3>Part/Product History</h3>
  <b-form @submit="getData">
    <b-form-row class="mb-2">
      <b-col class="mt-2">
        <b-form-checkbox v-model="onlyShowOnOff" @input="enforceOneCheckbox('onoff')">Only Show Turning On or Off</b-form-checkbox>
      </b-col>
      <b-col class="mt-2">
        <b-form-checkbox v-model="onlyShowLowStock" @input="enforceOneCheckbox('lowstock')">Only Show Within Alarm Level</b-form-checkbox>
      </b-col>
      <b-col cols=2 class="mt-2">
        <span style="text-align:right;">Only Show Results Before:</span><br/>
      </b-col>
      <b-col>
        <b-form-input type='date' v-model="startDate"></b-form-input>
        <b-form-input type='time' v-model="startTime"></b-form-input>
        <strong>Oldest Data Available:</strong> <NiceDate :value="oldestData" />
      </b-col>
    </b-form-row>
    <b-form-row class="mb-2">
      <b-col>
        <b-form-input v-model="search" placeholder="Part/Product Num" class="mx-1" autofocus />
      </b-col>
      <b-col cols=2>
        <b-btn type=submit>Search</b-btn>
      </b-col>
    </b-form-row>
  </b-form>

  <b-row v-if="items.length > 0">
    <b-col>
      <div v-if="partNums.some(x => x != 0)">
        <span v-if="partNums.length > 1" v-b-popover.hover="'Formerly known as: ' + partNums.slice(1).join(', ')">⚠️</span>
        Part Num: <router-link target="_blank" :to="{name: 'Qty Calculations', query: {partNum: partNums[0]}}">{{partNums[0]}}</router-link><br />
        <span v-if="partDescs.length > 1" v-b-popover.hover="'Formerly known as: ' + partDescs.slice(1).join(', ')">⚠️</span>
        Part Description: {{partDescs[0]}} <br />
      </div>
      <div v-if="productNums.some(x => x != 0)">
        <span v-if="productNums.length > 1" v-b-popover.hover="'Formerly known as: ' + productNums.slice(1).join(', ')">⚠️</span>
        Product Num: <router-link target="_blank" :to="{name: 'Qty Calculations', query: {productNum: productNums[0]}}">{{productNums[0]}}</router-link><br />
        <span v-if="productDescs.length > 1" v-b-popover.hover="'Formerly known as: ' + productDescs.slice(1).join(', ')">⚠️</span>
        Product Description: {{productDescs[0]}} <br />
      </div>
      <span v-if="qtyAlarms.length > 1">⚠️</span>
      Qty Alarm: {{qtyAlarms[0]}}
    </b-col>
    <b-col>
      <b-row>
      </b-row>
      <b-row>
        (FishIon column shows if the change was supposed to publish to the website via FishIon)
        <b-table :fields="columns" :items="items" striped hover :busy="busy">
          <template slot="updated_to_web" slot-scope="data">
            <span v-if="data.item.updated_to_web">✅</span><span v-else>❌</span>
          </template>
          <template slot="new_time" slot-scope="data">
            <NiceDate :value="data.item.new_time" is-utc />
          </template>
          <template slot="new_qty" slot-scope="data">
            {{data.item.new_qty}}
          </template>
          <template slot="old_time" slot-scope="data">
            <NiceDate :value="data.item.old_time" is-utc />
          </template>
          <template slot="old_qty" slot-scope="data">
            {{data.item.old_qty}}
          </template>
        </b-table>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col v-if="busy">
      <b-row class="justify-content-md-center align-items-center text-center">
        Please Wait...
      </b-row>
      <b-row class="justify-content-md-center align-items-center text-center">
        <fingerprint-spinner
          :animation-duration="1500"
          :size="300"
          color="#293a93"
          class="my-3"
        />
      </b-row>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { FingerprintSpinner } from 'epic-spinners';
import NiceDate from '../utility/NiceDate';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      oldestData: '',
      search: '',
      busy: false,
      columns: [
        { key: 'updated_to_web', label: 'FishIon', sortable: true },
        { key: 'new_time', label: 'Went to Date', sortable: true },
        { key: 'new_qty', label: 'Went to Value', sortable: true },
        { key: 'old_time', label: 'Initial Date', sortable: true },
        { key: 'old_qty', label: 'Initial Value', sortable: true },
      ],
      items: [],
      onlyShowLowStock: false,
      onlyShowOnOff: false,
      startDate: null,
      startTime: null,

      partNums: [''],
      partDescs: [''],
      productNums: [''],
      productDescs: [''],
      qtyAlarms: [''],
    };
  },
  components: {
    NiceDate,
    FingerprintSpinner,
  },
  mounted() {
    axios.get(`${BASE_API}/ams3-fishioninfo/part-product-history/oldest-data`)
    .then(response => {
      this.oldestData = response.data;
    }).catch(error => {
      console.error(`Error fetching oldest data available: ${error}`);
    })

    if (this.$route.query['search']) this.search = this.$route.query['search'];
    this.getData();
  },
  methods: {
    enforceOneCheckbox(name) {
      if (name === 'lowstock' && this.onlyShowLowStock == true) this.onlyShowOnOff = false;
      else if (name === 'onoff' && this.onlyShowOnOff == true) this.onlyShowLowStock = false;
    },
    getData(event) {
      if (event) event.preventDefault();
      if (this.search == null || this.search.trim() == '') return

      this.items.splice(0)
      this.busy = true;

      let requestUrl = `${BASE_API}/ams3-fishioninfo/part-product-history`;
      if (this.onlyShowOnOff) requestUrl += '/on-off';
      else if (this.onlyShowLowStock) requestUrl += '/stock-alarm';

      let start = moment();
      if (this.startDate != null) {
        if (this.startTime != null) start = moment(`${this.startDate} ${this.startTime}`);
        else start = moment(`${this.startDate}`);
      }

      axios.get(`${requestUrl}/${this.search}/${start.format('YYYY-MM-DDTHH:mm:ssZ')}`)
        .then(response => {
          response.data.forEach(item => {
            if (item.new_product) item._rowVariant = 'secondary';
            let color = this.highlightColor(item.new_qty, item.old_qty);
            item._cellVariants = {
              new_qty: color
            };
            item._editing = false;
          });
          this.items = response.data;

          if (this.items) {
            this.partNums = this.items.map(x => x.part_num).filter(this.getDistinct);
            this.partDescs = this.items.map(x => x.part_desc).filter(this.getDistinct);
            this.productNums = this.items.map(x => x.product_num).filter(this.getDistinct);
            this.productDescs = this.items.map(x => x.product_desc).filter(this.getDistinct);
            this.qtyAlarms = this.items.map(x => x.qty_alarm).filter(this.getDistinct);
          }
          this.busy = false;
        }).catch(error => {
          console.error(error);
          this.busy = false;
        });
    },
    getDistinct(value, index, self) {
      return self.indexOf(value) === index;
    },
    highlightColor(newQty, oldQty) {
      if (newQty < oldQty)
        if (newQty <= 0 && oldQty > 0) return 'danger';
        else return 'warning';
      else if (newQty > oldQty)
        if (newQty > 0 && oldQty <= 0) return 'success';
        else return 'secondary';
      return '';
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/inventory/PartProductHistory.vue